
<div
    class="Checkbox"
    :class="[
        {
            'Checkbox--hasError': hasError,
            'Checkbox--disabled': disabled,
            'Checkbox--indeterminate': indeterminate,
        },
        `Checkbox--${size}`,
        variant ? `Checkbox--${variant}` : '',
    ]"
>
    <label :for="computedId" class="Checkbox-label">
        <input
            ref="checkbox"
            type="checkbox"
            :id="computedId"
            :name="name"
            :disabled="disabled"
            :checked="value"
            :indeterminate.prop="indeterminate"
            :required="required"
            :data-testid="testId"
            :aria-checked="indeterminate ? 'mixed' : value.toString()"
            :aria-describedby="hasError ? `${computedId}-error` : undefined"
            @change="handleChange"
            @keydown="handleKeydown"
            class="Checkbox-input"
        />
        <div class="Checkbox-indicator">
            <i v-if="indeterminate" class="ri-subtract-line"></i>
            <i v-else-if="value" class="ri-check-line"></i>
        </div>
        <div class="Checkbox-content" v-if="$slots.default">
            <slot />
        </div>
    </label>
</div>
